module.exports = __webpack_public_path__ + "static/media/reportActive.74c91053.png";